module.exports = __webpack_public_path__ + "img/HomePanels.563f1b6b.png";